import { useCallback, useEffect, useState } from "react";
import EditFilter from "./EditFilter";
import { useDispatch, useSelector } from "react-redux";
import userProfileSelectors from '../../../../../../redux/UserProfile/selectors';
import { getEditCatalogVehicleCapacity, setEditCatalogVehicleCapacity } from "Store/AssetManagement/CatalogItemDropDownUpdate/CatalogItemDropDownUpdateAction";
import { addFilterGetData, popupInitialData } from "utils";
import successBee from "../../../../../assets/images/SuccessBee.svg";
import confirmationBee from "../../../../../assets/images/ConfirmationBee.svg";

const EditFilterContainer = (props?: any) => {
    const {
        itemList,
        setShowEditPopup,
        catalogItemValues
    } = props

    const dispatch = useDispatch();
    const [initialCapacityValue, setInitialCapacityValue] = useState<any>([]);
    const [changedCapacityValue, setChangedCapacityValue] = useState<any>([]);
    const [popUpContent, setPopupContent] = useState<any>(popupInitialData);

    const {
        userData,
        isVehicleCapacityEdited
    }: any = useSelector((state: any) => ({
        userData: userProfileSelectors.getUserDetails(state),
        isVehicleCapacityEdited: state.CatalogDropDownUpdateReducers.isVehicleCapacityEdited
    }))
    useEffect(() => {
        if (itemList?.length) {
            let val: any = []
            itemList?.map((item?: any) => {
                if (item?.value != null) {
                    val.push({ label: item?.label, value: item?.value })
                }
            })
            setChangedCapacityValue(val)
            setInitialCapacityValue(val)
        }
    }, [])

    useEffect(() => {
        if (isVehicleCapacityEdited && isVehicleCapacityEdited != null) {
            let decriptionTxt = (<p>Value is edited successfully.</p>);
            setPopupContent({
                ...popUpContent,
                titleImg: successBee,
                title: "SUCCESS",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                outlineBtnText: "Close",
                isSingleConfirmationBtn: true,
                popupOutlinebtnOnclick: () => {
                    hideDialog()
                    setShowEditPopup(false)
                    addFilterGetData('Capacity', dispatch, catalogItemValues, null)
                }
            })
        } else if (!isVehicleCapacityEdited && isVehicleCapacityEdited != null) {
            let decriptionTxt = (<p>Error occured while editting the value.</p>);
            setPopupContent({
                ...popUpContent,
                titleImg: confirmationBee,
                title: "SUCCESS",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                outlineBtnText: "Close",
                isSingleConfirmationBtn: true,
                popupOutlinebtnOnclick: () => {
                    hideDialog()
                    dispatch(setEditCatalogVehicleCapacity(null))
                }
            })
        }
    }, [isVehicleCapacityEdited])

    const hideDialog = () => {
        setPopupContent({ ...popUpContent, isDialogVisible: false })
    };

    const validation = (value?: any) => {
        let val = changedCapacityValue?.length ? JSON.parse(JSON.stringify(changedCapacityValue)) : [];
        let error = "";
        if (value?.trim() === "") {
            error = "Please enter a value"
        } else if (val?.filter((item?: any) => item?.label?.trim() == value?.trim())?.length >= 1) {
            error = "Given capacity value already exists"
        } else if (value?.length > 250){
            error = "Please enter a value less than 250 characters"
        } else {
            error = ""
        }
        return error;
    }

    const onEditValueChange = (e: any, id?: any) => {
        let val = changedCapacityValue?.length ? JSON.parse(JSON.stringify(changedCapacityValue)) : [];
        val?.map((item?: any) => {
            if (item?.value === id) {
                item.label = e.target.value
                item.error = validation(e.target.value)
            }
        })
        setChangedCapacityValue(val)
    }

    const isValidForSave = useCallback(() => {
        let errorCount = 0
        changedCapacityValue?.map((item?: any) => {
            if (item?.error?.length) {
                errorCount = errorCount + 1;
            }
        })
        if (errorCount != 0) {
            return true
        }
        let count = 0
        initialCapacityValue?.map((item?: any) => {
            if (item?.value != null) {
                let valTemp = changedCapacityValue?.find((itemTemp?: any) => itemTemp?.value === item?.value)
                if (valTemp?.label !== item?.label) {
                    count = count + 1;
                }
            }
        })
        if (count === 0) {
            return true
        }
        return false;
    }, [changedCapacityValue])

    const onAddClick = () => {
        if (!isValidForSave()) {
            let ChangedItemTemp: any = []
            initialCapacityValue?.map((item?: any) => {

                if (item?.value != null) {
                    let valTemp = changedCapacityValue?.find((itemTemp?: any) => itemTemp?.value === item?.value)
                    if (valTemp?.label !== item?.label) {
                        ChangedItemTemp.push({
                            attributeValueId: valTemp?.value,
                            attributeValue: valTemp?.label
                        })
                    }
                }
            })
            let payload = {
                savedBy: userData?.emailId,
                catalogAttributeUpdateItems: ChangedItemTemp,
                subTypeId: catalogItemValues?.vehicleType?.orderRequestSubTypeId
            }
            dispatch(getEditCatalogVehicleCapacity(payload))
        }
    }

    const onClickCancel = () => {
        setChangedCapacityValue(initialCapacityValue);
        setShowEditPopup(false)
    }

    return (
        <EditFilter
            changedCapacityValue={changedCapacityValue}
            onEditValueChange={onEditValueChange}
            onAddClick={onAddClick}
            isValidForSave={isValidForSave}
            onClickCancel={onClickCancel}
            hideDialog={hideDialog}
            popUpContent={popUpContent}
        />
    )
}

export default EditFilterContainer;

